import React from 'react'

const EmptyIllustration = () => (
  <svg
    viewBox="0 0 240 200"
    style={{ width: '176px', height: '176px', margin: '0 auto', display: 'block' }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="bgGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#DBEAFE" />
        <stop offset="100%" stopColor="#EFF6FF" />
      </linearGradient>
      <linearGradient id="bellGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#60A5FA" />
        <stop offset="100%" stopColor="#2563EB" />
      </linearGradient>
    </defs>
    <circle cx="120" cy="100" r="80" fill="url(#bgGrad)" />
    <circle cx="120" cy="100" r="60" fill="#FFFFFF" opacity="0.6" />
    <g transform="translate(80,60)">
      <path
        d="M40 10 C40 4, 46 0, 52 0 C58 0, 64 4, 64 10 C78 16, 82 30, 82 46 L82 62 C82 66, 84 68, 86 70 L18 70 C20 68, 22 66, 22 62 L22 46 C22 30, 26 16, 40 10 Z"
        fill="url(#bellGrad)"
      />
      <path
        d="M44 76 C44 82, 48 86, 52 86 C56 86, 60 82, 60 76"
        stroke="#1E40AF"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="78" cy="14" r="10" fill="#F59E0B" />
      <path d="M74 14 L77 17 L83 11" stroke="white" strokeWidth="2" strokeLinecap="round" fill="none" />
    </g>
    <circle cx="40" cy="60" r="3" fill="#93C5FD" />
    <circle cx="200" cy="70" r="4" fill="#BFDBFE" />
    <circle cx="50" cy="150" r="3" fill="#BFDBFE" />
    <circle cx="195" cy="145" r="3" fill="#93C5FD" />
    <path d="M30 110 L40 110 M35 105 L35 115" stroke="#60A5FA" strokeWidth="2" strokeLinecap="round" />
    <path d="M205 110 L215 110 M210 105 L210 115" stroke="#60A5FA" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

export default EmptyIllustration



// WEBPACK FOOTER //
// ./src/components/Notifications/EmptyIllustration.js